import { Add, PlayArrowOutlined, Save } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import {
  Box,
  Breadcrumbs,
  Button,
  CircularProgress,
  Paper,
  Stack,
  Step,
  StepConnector,
  stepConnectorClasses,
  StepLabel,
  Stepper,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import {
  useBlocker,
  useLocation,
  useNavigate,
  useOutletContext,
} from "react-router-dom";
import NewAlertModal from "../../../componentes/newAlertModal";
import { HostsReview } from "./hostsReview";
import api from "../../../services/api";
import { useNotification } from "../../../componentes/notificationProvider";

const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: "calc(-50% + 16px)",
    right: "calc(50% + 16px)",
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.sucess.main,
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.sucess.main,
    },
  },
}));

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
    width: "100%",
  },
  boxHeader: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    mb: 1,
  },
  boxTitle: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "start",
    alignItems: "center",
    color: "primary.main",
    width: "100%",
  },
  titleAndLinkPage: {
    flexGrow: 1,
    fontWeight: 400,
    fontSize: "1.25rem",
    mt: 1,
    mb: 2,
  },
};

export default function AdditionMassHost() {
  const location = useLocation();
  const [csvData, setCsvData] = useState(location.state?.initialCsvData || []);
  const [activeStep, setActiveStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [openAlertModal, setOpenAlertModal] = useState(false);
  const [hasTableErrors, setHasTableErrors] = useState(false);
  const [isTesting, setIsTesting] = useState(false);
  const [testsCompleted, setTestsCompleted] = useState(false);
  const [templates, setTemplates] = useState([]);
  const [proxys, setProxys] = useState([]);

  const notify = useNotification();
  const theme = useTheme();
  const navigate = useNavigate();
  const reviewRef = useRef();

  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { setTitlePage } = useOutletContext();

  const blocker = useBlocker(({ currentLocation, nextLocation }) => {
    const hasData = csvData && csvData.length > 0;

    const isLeaving = !nextLocation.pathname.startsWith("/easyAdd");

    return hasData && isLeaving;
  });
  useEffect(() => {
    if (blocker.state === "blocked") {
      setOpenAlertModal(true);
    }
  }, [blocker]);

  useEffect(() => {
    setTitlePage("");
    apiGetTemplates();
    apitGetProxys();
  }, [setTitlePage]);

  async function apiGetTemplates() {
    try {
      const response = await api.get("/predefinicoes/findMany");
      setTemplates(response?.data || []);
    } catch (error) {
      console.error(error);
      notify(
        error?.response?.data?.message || "Erro ao buscar templates",
        "error",
      );
    }
  }

  async function apitGetProxys(params) {
    try {
      const reponse = await api.get("/easyAdd/zabbix/proxys", { params });
      setProxys(reponse?.data);
    } catch (error) {
      console.error(error);
      notify(
        `Error:${error?.response?.data?.error || "Ao buscar os proxys"} `,
        "error",
      );
    }
  }

  const handleBack = () => {
    if (activeStep === 1) {
      setCsvData([]);
      setTestsCompleted(false);
    } else {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }
  };

  const handleNext = async (onlySuccess) => {
    if (activeStep === 1) {
      try {
        if (!testsCompleted) {
          await reviewRef.current.processMassTests();
          setTestsCompleted(true);
          return;
        }

        if (testsCompleted) {
          await reviewRef.current.processAddHostsInMass(onlySuccess);
          setTestsCompleted(false);
        }
      } catch (error) {
        console.error("Erro no processo:", error);
      }
      return;
    }
  };

  const handleAddHostsInMass = async (hosts) => {
    const currentTableData = reviewRef.current?.getRawTableData() || [];
    try {
      setActiveStep(2);
      const response = await api.post("easyAdd/zabbix/createHostsInMass", {
        hosts: hosts,
      });

      const { summary, details } = response.data;

      if (summary.failed === 0) {
        notify(`${summary.total} hosts adicionados com sucesso!`, "success");
        navigate("/easyAdd");
        return;
      }

      const errorMessages = details
        .filter((d) => d.status === "error")
        .map((d) => `${d.host}: ${d.message}`)
        .join("\n");

      const failedIds = details
        .filter((d) => d.status === "error")
        .map((d) => d.id);

      const failedDataToReturn = currentTableData.filter((item) =>
        failedIds.includes(item.id),
      );

      setCsvData(failedDataToReturn);

      setActiveStep(1);

      if (summary.success > 0) {
        notify(
          `Atenção: ${summary.success} sucessos e ${summary.failed} falhas.\n\nDetalhes dos erros:\n${errorMessages}`,
          "warning",
          15000,
        );
      } else {
        notify(
          `Nenhum host foi adicionado. Detalhes dos erros:\n${errorMessages}`,
          "error",
          15000,
        );
      }
    } catch (error) {
      notify(
        error?.response?.data?.error ||
          error?.response?.data?.message ||
          "Erro crítico ao adicionar hosts em massa.",
        "error",
      );
      setActiveStep(1);
    }
  };
  const steps = [
    {
      label: "Upload CSV",
      description: null,
    },
    {
      label: "Revisão",
      description: (
        <HostsReview
          ref={reviewRef}
          onValidationStatusChange={(hasError) => setHasTableErrors(hasError)}
          csvData={csvData}
          setCsvData={setCsvData}
          isTesting={isTesting}
          setIsTesting={setIsTesting}
          onSaveHosts={handleAddHostsInMass}
          templates={templates}
          proxys={proxys}
        />
      ),
    },
    {
      label: "Adição de hosts",
      description: (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          gap={0.5}
          flex={1}
          minHeight={400}
        >
          <Stack
            sx={{
              backgroundColor: theme.palette.background.textField,
              borderRadius: "100%",
              height: 60,
              width: 60,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <CircularProgress size={36} />
          </Stack>
          <Typography variant="subtitle1" color="text.primary">
            Cadastrando Hosts...
          </Typography>
          <Typography variant="subtitle2" color="text.secondary">
            Isso pode levar alguns segundos
          </Typography>
        </Box>
      ),
    },
  ];

  return (
    <Box sx={styles.container}>
      <Breadcrumbs
        separator={<Typography sx={styles.titleAndLinkPage}>/</Typography>}
      >
        <Typography
          sx={{
            ...styles.titleAndLinkPage,
            cursor: "pointer",
            fontSize: "1.15rem",
            "&:hover": {
              color: "primary.dark",
              textDecoration: "underline",
            },
          }}
          onClick={() => {
            navigate(-1);
          }}
        >
          Adição de host
        </Typography>

        <Typography
          sx={{ ...styles.titleAndLinkPage, color: theme.palette.text.primary }}
        >
          Importação em Massa
        </Typography>
      </Breadcrumbs>
      <Paper
        sx={{
          padding: 2,
          borderRadius: "8px",
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <Stepper
          activeStep={activeStep}
          orientation="horizontal"
          connector={<QontoConnector theme={theme} />}
        >
          {steps.map(({ label }) => (
            <Step key={label}>
              <StepLabel>{isMobile ? "" : label}</StepLabel>
            </Step>
          ))}
        </Stepper>
        <Stack sx={{ height: "100%", flex: 1 }}>
          {steps[activeStep]?.description}
        </Stack>
        {activeStep !== steps.length - 1 && (
          <Stack
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              gap: 2,
            }}
          >
            <Button
              variant="text"
              onClick={handleBack}
              size="small"
              disabled={isTesting}
            >
              {activeStep === 1 ? "Limpar" : "Voltar"}
            </Button>

            {activeStep === 1 && testsCompleted && (
              <LoadingButton
                loading={loading}
                variant="outlined"
                size="medium"
                onClick={() => handleNext(true)}
                disabled={hasTableErrors || isTesting}
                startIcon={<Add />}
              >
                Cadastrar aprovados
              </LoadingButton>
            )}
            <LoadingButton
              loading={loading}
              variant="contained"
              size="medium"
              onClick={() => handleNext(false)}
              disabled={
                (activeStep === 1 && hasTableErrors) || isTesting || loading
              }
              startIcon={
                activeStep === 1 ? (
                  testsCompleted ? (
                    <Add />
                  ) : (
                    <PlayArrowOutlined />
                  )
                ) : (
                  <Save />
                )
              }
            >
              {activeStep === 1
                ? testsCompleted
                  ? "Cadastrar todos"
                  : "Iniciar testes"
                : "Cadastrar"}
            </LoadingButton>
          </Stack>
        )}
      </Paper>
      <NewAlertModal
        openModal={openAlertModal}
        setOpenModal={setOpenAlertModal}
        buttonText={"Prosseguir"}
        buttonCancelText={"Voltar"}
        confirmar={false}
        handleButton={() => {
          blocker.proceed();
        }}
        handleCancel={() => {
          setOpenAlertModal(false);
          blocker.reset();
        }}
        severity={"warning"}
        singleButton={false}
        textContent={
          "Se você sair da página, os dados do CSV serão perdidos. Tem certeza que deseja sair?"
        }
      />
    </Box>
  );
}
